import React from 'react'
import { Button } from 'components'

function Element({
  children,
  className = 'basic-list',
  hasNextPage = false,
  onClick = () => {},
  margin = 0,
  isData = true,
}) {
  return (
    <>
      <div style={{ marginBottom: `${margin}px` }}>
        <ul className={className}>{children}</ul>
        {hasNextPage && <Button type="more" className="mt24" onClick={() => onClick()} />}
      </div>
      {children &&
        (children[0] === undefined || children[0].length === 0) &&
        (isData ? (
          <div className="flex-1 flex-align-center" style={{ marginTop: '20px' }}>
            <div className="flex-col flex-item-center">
              <span className="icon-message-gray"></span>
              <p className="c-6 mt24">조회된 데이터가 없습니다. </p>
            </div>
          </div>
        ) : (
          <div className="no-data">조회내역이 없습니다.</div>
        ))}
    </>
  )
}

export default Element
